import { useTranslation } from "react-i18next";
import { IconWithTooltip } from "@/playground/components/DevHome/table/components/IconWithTooltip/IconWithTooltip";
import type { IconCellProps } from "./CellIcon.decl";

export function CellIcon({ tooltip, color, icon, dataTest }: IconCellProps) {
  const { t } = useTranslation();
  return (
    <div className="w-6">
      <IconWithTooltip
        icon={icon}
        color={color}
        tooltip={typeof tooltip === "string" ? t(tooltip) : tooltip}
        dataTest={dataTest}
      />
    </div>
  );
}
